<div id="preloader" [hidden]='!display'>
    <div id="status" [ngStyle]="{width: size, height: size}">
        <div [ngClass]="{'spinner-border-primary': !noBg, 'spinner-border-white': noBg, 'spinner-login': login}"
            [ngStyle]="{'width': size, 'height': size}">
        </div>
    </div>
</div>